import React, { forwardRef } from 'react';
import { Card, CardContent, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const AppSearchInput = forwardRef(({
    placeholder = "Search...",
    value,
    onChange,
    onSearch,
    renderAction = () => (<IconButton onClick={onSearch} type="button"> <SearchIcon /> </IconButton>),
    ...props
}, ref) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onSearch) {
            onSearch(e);
        }
    };

    return (
        <Card ref={ref} {...props}>
            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyDown={handleKeyDown}
                />
                {renderAction && renderAction()}
            </CardContent>
        </Card>
    );
});

export { AppSearchInput };